export const settingsService = {
    getSiteSettings
};

function getSiteSettings() {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
    };

    return fetch('/api/settings/', requestOptions)
        .then(handleResponse)
        .then(settings => {
            return settings;
        });
}

function handleResponse(response) {

    return response.text()
        .then(text => {
            const data = text && JSON.parse(text);

            if (!response.ok) {
                const error = (data && data.message) || response.statusText;
                return Promise.reject(error);
            }

            return data;
        }).catch((error) => {
            // eslint-disable-next-line
            console.log(error);
        });
}